import Link from 'next/link';
import styles from './LogoLink.module.scss';
import { type Locale } from '@/lib/i18n/locales';

interface LogoLinkProps {
  locale: Locale;
  className?: string;
}

export default function LogoLink({ locale, className = '' }: LogoLinkProps) {
  return (
    <Link
      href={`/${locale}`}
      className={`${styles.logoLink} ${className}`}
      aria-label="LYRA PROMO - Go to homepage"
    >
      <p>LYRA PROMO</p>
    </Link>
  );
}
